import { useState, useEffect } from "react";
import api from "../../services/api";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { faSquarePlus } from "@fortawesome/free-solid-svg-icons";
import { faSquareMinus } from "@fortawesome/free-solid-svg-icons";
import EditModal from "../ui/EditModal.js";
import { normalizar } from "../../common/stringNormalizer.js";

const AddComorbilidad = () => {
  const [mostrarDescripcion, setMostrarDescripcion] = useState({});
  const [AllComorbilidades, setAllComorbilidades] = useState([]);
  const [comorbilidadNombre, setComorbilidadNombre] = useState("");
  const [comorbilidadDescripcion, setComorbilidadDescripcion] = useState("");
  const [selectedComorbilidad, setSelectedComorbilidad] = useState(null);
  const [filtroEstado, setFiltroEstado] = useState("activas");
  useEffect(() => {
    getComorbilidades();
  }, []);

  const editFields = [
    { name: "Nombre", label: "Nombre de la Comorbilidad", type: "text", required: true },
    { name: "Descripcion", label: "Descripción de la Comorbilidad", type: "text", required: false }
  ];

  const createComorbilidad = async (e) => {
    e.preventDefault();

    const existe = AllComorbilidades.some(
      (comorbilidad) => normalizar(comorbilidad.Nombre) === normalizar(comorbilidadNombre)
    );

    if (existe) {
      Swal.fire({
        icon: "warning",
        title: "Duplicado",
        text: "Ya existe una comorbilidad con ese nombre.",
        confirmButtonColor: "#3085d6"
      });
      return;
    }

    try {
      await api.post(`/comorbilidades`, {
        Nombre: comorbilidadNombre,
        Descripcion: comorbilidadDescripcion,
      });
      getComorbilidades();
      setComorbilidadNombre("");
      setComorbilidadDescripcion("");
      Swal.fire({
        icon: "success",
        title: "Guardado",
        text: "La comorbilidad fue guardada exitosamente.",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Error al crear la comorbilidad:", error);
      Swal.fire({
        icon: "error",
        title: "Error al guardar",
        text: "Ocurrió un error al crear la comorbilidad.",
      });
    }
  };

  const getComorbilidades = async () => {
    try {
      const response = await api.get(`/comorbilidadesAll`);
      setAllComorbilidades(response.data);
    } catch (error) {
      console.error("Error al obtener comorbilidades: " + error.message);
    }
  };

  const handleEditComorbilidad = async (values) => {
    try {
      await api.patch(`/comorbilidad/updateComorbilidad/${values.IdComorbilidad}`, { Nombre: values.Nombre, Descripcion: values.Descripcion });
      Swal.fire({
        icon: "success",
        title: "Comorbilidad actualizada",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (error) {
      console.error("Error al actualizar:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al actualizar la comorbilidad.",
      });
    }
    setSelectedComorbilidad(null);
    getComorbilidades();
  };

const cambiarEstado = async (IdComorbilidad) => {
  try {
    const comorbilidad = AllComorbilidades.find(c => c.IdComorbilidad === IdComorbilidad);
    const nuevoEstado = comorbilidad.estado === 1 ? 0 : 1;

    await api.patch(`/comorbilidades/cambiarEstadoComorbilidad/${IdComorbilidad}`);
    getComorbilidades();

    Swal.fire({
      icon: "success",
      title: nuevoEstado === 1 ? "Activada" : "Desactivada",
      text: `La comorbilidad ha sido ${nuevoEstado === 1 ? "activada" : "desactivada"} correctamente.`,
      timer: 1500,
      showConfirmButton: false,
    });
  } catch (error) {
    console.error("Error al cambiar estado:", error);

    const mensaje = error.response?.status === 400
      ? "No se puede desactivar: esta comorbilidad está asociada a una o más patologías."
      : "Ocurrió un error al cambiar el estado de la comorbilidad.";

    Swal.fire({
      icon: "error",
      title: "Error",
      text: mensaje,
    });
  }
};


const filtrarComorbilidades = () => {
  if (filtroEstado === "activas") {
    return AllComorbilidades.filter(c => c.estado === 1);
  }
  if (filtroEstado === "inactivas") {
    return AllComorbilidades.filter(c => c.estado === 0);
  }
  return AllComorbilidades;
};


  const columnas = [
    {
      name: "Nombre",
      selector: row => row.Nombre,
      sortable: true,
      width: "15vw",
    },
    {
      name: "Descripción",
      cell: (row) => {
        const toggleDescripcion = () => {
          setMostrarDescripcion({
            ...mostrarDescripcion,
            [row.IdComorbilidad]: !mostrarDescripcion[row.IdComorbilidad],
          });
        };

        const descripcion = row.Descripcion || "Sin descripción";
        const mostrarBoton = row.Descripcion && row.Descripcion.length > 40;

        return (
          <div style={{ display: "flex", alignItems: "center", width: "30vw" }}>
            <div style={{ flex: 1, whiteSpace: mostrarDescripcion[row.IdComorbilidad] ? "normal" : "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              {!mostrarDescripcion[row.IdComorbilidad] ? (descripcion.length > 40 ? descripcion.substring(0, 40) + "..." : descripcion) : descripcion}
            </div>
            {mostrarBoton && (
              <button className="btn" onClick={(e) => { e.preventDefault(); toggleDescripcion(); }}>
                {mostrarDescripcion[row.IdComorbilidad] ? "Ver Menos" : "Ver Más"}
              </button>
            )}
          </div>
        );
      },
      sortable: true,
      width: "30vw",
    },
    {
      cell: (row) => (
        <button
          className="button is-small is-info"
          title="Editar"
          onClick={() => setSelectedComorbilidad(row)}
        >
          <FontAwesomeIcon icon={faPencil} />
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      compact: true,
    },
    {
      cell: (row) => (
        row.estado === 1 ?
          <FontAwesomeIcon icon={faSquarePlus} style={{ color: "#37ff00", cursor: "pointer" }} size="2xl" onClick={() => cambiarEstado(row.IdComorbilidad)} /> :
          <FontAwesomeIcon icon={faSquareMinus} style={{ color: "#ff0000", cursor: "pointer" }} size="2xl" onClick={() => cambiarEstado(row.IdComorbilidad)} />
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      compact: true,
    }
  ];

  const paginationOptionsES = {
  rowsPerPageText: 'Filas por página',
  rangeSeparatorText: 'de',
  selectAllRowsItem: true,
  selectAllRowsItemText: 'Todos',
};
  return (
    <div className="columns mt-5 is-centered">
      <div>
        <div className="notification is-primary">
          <strong>Ingresa el nombre de la comorbilidad.</strong>
        </div>
        <form onSubmit={createComorbilidad}>
          <div className="field">
            <div className="container">
              <label className="label required">Nombre de la Comorbilidad</label>
              <div className="control">
                <input
                  type="text"
                  className="input"
                  value={comorbilidadNombre}
                  onChange={(e) => setComorbilidadNombre(e.target.value)}
                  placeholder="Nombre"
                  required
                />
              </div>
            </div>
          </div>

          <div className="field">
            <div className="container">
              <label className="label">Descripción de la Comorbilidad</label>
              <div className="control">
                <input
                  type="text"
                  className="input"
                  value={comorbilidadDescripcion}
                  onChange={(e) => setComorbilidadDescripcion(e.target.value)}
                  placeholder="Descripción"
                />
              </div>
            </div>
          </div>

          <div className="field">
            <button type="submit" className="button is-success">Guardar</button>
          </div>
        </form>

        <br />

<div style={{ display: 'flex', gap: '10px', marginBottom: '1rem' }}>
  {["todas", "activas", "inactivas"].map((estado) => (
    <button
      key={estado}
      onClick={() => setFiltroEstado(estado)}
      type="button"
      style={{
        padding: "6px 16px",
        border: "none",
        borderRadius: "20px",
        backgroundColor: filtroEstado === estado ? "#d1f5d3" : "#f0f2f5",
        color: filtroEstado === estado ? "#075e54" : "#333",
        fontWeight: filtroEstado === estado ? "bold" : "normal",
        boxShadow:
          filtroEstado === estado
            ? "inset 0 0 0 1px #1ebea5"
            : "inset 0 0 0 1px #ccc",
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
        fontSize: "0.9rem",
      }}
    >
      {estado.charAt(0).toUpperCase() + estado.slice(1)}
    </button>
  ))}
</div>


        <div style={{ border: '1px solid gray', borderRadius: '8px' }}>
          <DataTable
            pagination
              paginationComponentOptions={paginationOptionsES}

            columns={columnas}
            data={filtrarComorbilidades()}
            dense={false}
          />
        </div>

        {selectedComorbilidad && (
          <EditModal
            fields={editFields}
            initialValues={selectedComorbilidad}
            onSubmit={handleEditComorbilidad}
            onClose={() => setSelectedComorbilidad(null)}
            title="Editar Comorbilidad"
          />
        )}
      </div>
    </div>
  );
};

export default AddComorbilidad;
